import React from 'react';
import { ApplicationErrorsTable } from './components/ApplicationErrorsTable';

export const AdminApplicationErrorsIndex = () => {
  return (
    <div>
      <ApplicationErrorsTable />
    </div>
  );
};
